/** @jsxRuntime classic */ // <-- remove this when TS updated to 4.1
/** @jsx jsx */ // <-- remove this when TS updated to 4.1
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import { Text } from '../..';
import { pricePresenter } from '../../../utils';
import { Plan, ThemeProps } from '../../../types';

interface BasketProps extends Plan {
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
  /**
   * The details of the plan selected
   */
  details: string;
  /**
   * The frequency of pricing to display to the user
   */
  priceFrequency: string;
  /**
   * The title of the basket
   */
  title: string;
  accentMessage: string;
  detailsMessage: string;
  additionalInfo: string;
}

const Basket = ({
  className,
  currency,
  discountPrice,
  priceFrequency,
  title,
  totalPrice,
  currencySymbols,
  discounts,
  accentMessage,
  detailsMessage,
  additionalInfo,
  details
}: BasketProps) => {
  const theme: ThemeProps = useTheme();

  return (
    <section className={className}>
      <div css={{
        justifyContent: 'space-between',
      }}>
        <Text as='span' color='primary' variant='accordionHeader' weight='medium'>
          {title}
        </Text>
        <div className='price-container'>
          {!!!(discounts?.length === 0) && totalPrice && (
            <Text
              as='span'
              color='muted'
              css={{
                marginRight: 4,
                textDecoration: 'line-through',
              }}
              variant='small'
              weight='medium'>
              {`${pricePresenter(totalPrice, currencySymbols, currency)}`}
            </Text>
          )}
          <Text
            as='span'
            color={!!discountPrice && totalPrice ? 'accent' : 'accent'}
            variant='price'
            weight='bold'>
            {`${pricePresenter(!!!(discounts?.length === 0) ? discountPrice : totalPrice, currencySymbols, currency)}`}
            <Text as='span' variant='priceFrequency' weight='light'>
              {priceFrequency}
            </Text>
          </Text>
        </div>
      </div>
      <Text
        as='p'
        color='muted'
        customRenderer={{
          break: () => <span css={{ display: 'block', marginBottom: 10 }} />,
          strong: ({ children }: any) => (
            <strong
              css={{
                color: theme.colors.text.muted,
                display: 'block',
                fontWeight: theme.fonts.weights.bold,
              }}>
              {children}
            </strong>
          ),
        }}
        withMarkdown={true}>
      </Text>
      <div css={{
        justifyContent: 'flex-start'
      }}>
        <div css={{
          backgroundColor: theme.colors.accent,
          borderRadius: 6,
          padding: '4px 8px'
        }}>
          <Text color='white'>{accentMessage}</Text>
        </div>
        <div css={{
          paddingLeft: '0.5em'
        }}>
          <Text>{detailsMessage}</Text>
        </div>
      </div>
      <Text css={{
        marginBottom: details ? '0.5em' : '0'
      }}>
        {details}
      </Text>
      <Text variant='listItem'>{additionalInfo}</Text>
    </section>
  );
};

const StyledBasket = styled((props: any) => <Basket {...props} />)`
  ${({ theme }: { theme: ThemeProps }) => ({
    backgroundColor: theme.colors.common.lightGrey,
    borderColor: theme.colors.accent,
    borderStyle: 'solid',
    borderRadius: theme.radii.basket,
    borderWidth: 2,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 24,
    padding: '8px 16px',
    width: '100%',
    '.price-container': {
      alignItems: 'flex-end',
    },
    div: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 8,
    },
  })}
`;

export default StyledBasket;
